import { Text, View } from "@react-pdf/renderer";
import { CustomerApproval } from "models/Order";
import SectionHeader from "./SectionHeader";
import { color } from "../styles";
import { formatDateTime } from "utilities/formatDateTime";
import CheckIcon from "../graphics/CheckIcon";
import LabelledData from "./LabelledData";
import { useLocalization } from "../localization/LocalizationContext";

type InspectionsSectionProps = { inspections: CustomerApproval[] };

const InspectionsSection: React.FC<InspectionsSectionProps> = (props) => {
  const { inspections } = props;
  const { strings } = useLocalization();
  const t = strings.inspectionsSection;

  return (
    <View>
      <SectionHeader>
        <Text>{t.title}</Text>
      </SectionHeader>

      {inspections.map((inspection) => (
        <View
          key={inspection.id}
          style={{
            paddingVertical: 15,
            paddingHorizontal: 20,
            gap: 10,
            backgroundColor: color.lightGrey,
            marginBottom: 10,
            fontSize: 12,
          }}
        >
          <Text style={{ position: "absolute", top: 15, right: 20, fontSize: 10 }}>
            {formatDateTime(inspection.timestamp)}
          </Text>

          <View
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 5,
              fontSize: 12,
            }}
          >
            {inspection.customerOnSite ? (
              <>
                <CheckIcon width={18} height={16} />

                <Text style={{ marginTop: 2 }}>{t.withCustomerOnSite}</Text>
              </>
            ) : (
              <Text>{t.withoutCustomerOnSite}</Text>
            )}
          </View>

          {inspection.customerOnSite && (
            <>
              <LabelledData label={`${t.customerName}:`}>{inspection.customerName}</LabelledData>

              <LabelledData label={`${t.approvedInstallations}:`}>
                {inspection.approvedChecklists.map((checklist) => checklist.roomName).join(", ")}
              </LabelledData>
            </>
          )}

          {!inspection.customerOnSite && (
            <>
              <LabelledData label={`${t.personContacted}:`}>
                {inspection.triedToContactPerson}
              </LabelledData>

              <LabelledData label={`${t.phone}:`}>
                {inspection.triedToContactPhoneNumber}
              </LabelledData>
              <LabelledData label={`${t.time}:`}>
                {inspection.triedToContactAt && formatDateTime(inspection.triedToContactAt)}
              </LabelledData>

              <LabelledData label={`${t.comment}:`}>{inspection.notOnSiteDescription}</LabelledData>
            </>
          )}
        </View>
      ))}
    </View>
  );
};

export default InspectionsSection;
